import { forwardRef } from "react";

interface ChartEmptyStateProps {
  message: string;
}

export const ChartEmptyState = forwardRef<HTMLDivElement, ChartEmptyStateProps>(
  ({ message }, ref) => (
    <div
      ref={ref}
      className="flex flex-col items-center justify-center gap-2 min-h-[180px] p-6 bg-white rounded-lg shadow-md text-center"
    >
      <span className="text-[13px] text-gray-400">{message}</span>
    </div>
  )
);

ChartEmptyState.displayName = "ChartEmptyState";
